module.exports = __webpack_public_path__ + "static/media/logo-remente.9a0ba9bf.svg";